import React from 'react';

export default function WorkflowPagination({ page, total, onChange, disabled }) {
  const pages = Math.max(1, Math.ceil(total / 100));
  if (pages <= 1) return null;
  return <nav aria-label="Results pages" className="d-flex gap-3 align-items-center my-3">
    <button className="btn btn-sm btn-outline-secondary" disabled={disabled || page <= 1} onClick={() => onChange(page - 1)}>Previous</button>
    <span>Page {page} of {pages}</span>
    <button className="btn btn-sm btn-outline-secondary" disabled={disabled || page >= pages} onClick={() => onChange(page + 1)}>Next</button>
  </nav>;
}
